module.exports = __webpack_public_path__ + "img/titleist_back_img1_m.d59f7c94.jpg";